import { Link, useMatches } from "react-router";
import { getVisningsNavnForRouteId } from "@/routerUtil";

const AppBreadcrumbs = () => {
  const matches = useMatches();

  return (
    <nav className="navbar container-xxl small py-4 px-4 justify-content-start gap-2">
      {matches.length > 0 && <span className="fw-semibold">Du er her:</span>}
      {matches
        .map((match) => {
          const visningsNavn = getVisningsNavnForRouteId(match.id as any);
          if (!visningsNavn) return null;
          return { visningsNavn, id: match.id, pathName: match.pathname };
        })
        .filter((m) => m !== null)
        .map((crumb, i, filteredMatches) => {
          if (!crumb) return null;
          const { id, pathName, visningsNavn } = crumb;
          return (
            <span key={id}>
              {i < filteredMatches.length - 1 && (
                <>
                  <Link
                    className="link--hover fw-light text-body"
                    to={pathName}
                  >
                    {" "}
                    {visningsNavn}
                  </Link>{" "}
                  /{" "}
                </>
              )}
              {i === filteredMatches.length - 1 && (
                <span className="fw-semibold">{visningsNavn}</span>
              )}
            </span>
          );
        })}
    </nav>
  );
};

export default AppBreadcrumbs;
